<template>

  <div id="app">
    <LoaderComponent />
    <Sidebar v-if="showSidebar" />
    <div class="main-content" :class="{ 'with-sidebar': showSidebar }">
      <router-view /> 
    </div>
  </div>
</template>

<script>
import Sidebar from "@/layout/Sidebar.vue";
 import LoaderComponent from "@/components/Loader.vue";


export default {
  name: "App",
  components: {
    Sidebar,
    LoaderComponent
  },
  computed: {
    showSidebar() {
      return this.$route.path !== "/login" && 
             this.$route.path !== "/reset-password" && 
             this.$route.path !== "/forgot-password";
    },
  },
};
</script>
<style>
.with-sidebar {
  margin-right: 250px; 
}
@font-face {
  font-family: 'Cairo';
  src: url('@/assets/fonts/Cairo-VariableFont_slnt,wght.ttf') format('truetype'),
       url('@/assets/fonts/Cairo-VariableFont_slnt,wght.ttf') format('woff');
  font-weight: 400; 
  font-style: normal;
}

@font-face {
  font-family: 'Cairo';
  src: url('@/assets/fonts/Cairo-VariableFont_slnt,wght.ttf') format('truetype'),
       url('@/assets/fonts/Cairo-VariableFont_slnt,wght.ttf') format('woff');
  font-weight: 400;
  font-style: normal;
}

body {
  font-family: 'Cairo', sans-serif !important;
}
</style>
